(function () {
  "use strict";

  var activeNav = null;
  var activeToggle = null;
  var activeOverlay = null;
  var scrollTicking = false;
  var SCROLL_THRESHOLD = 24;
  var SCROLL_DIRECTION_EPSILON = 1;
  var MOBILE_MQ = window.matchMedia("(max-width: 1199px)");
  var REDUCED_MOTION_MQ = window.matchMedia("(prefers-reduced-motion: reduce)");

  function isMobileNav() {
    return MOBILE_MQ.matches;
  }

  function releaseNavFocus(nav, toggle) {
    if (!nav || !toggle) return;
    if (nav.contains(document.activeElement)) {
      toggle.focus();
    }
  }

  function setNavOpen(nav, toggle, open) {
    if (!nav || !toggle) return;

    var header = nav.closest("[data-site-header]");
    var overlay =
      header && header.querySelector("[data-site-header-overlay]");

    if (!open && isMobileNav()) {
      releaseNavFocus(nav, toggle);
    }

    nav.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    nav.setAttribute("aria-hidden", open ? "false" : "true");

    if (!open && isMobileNav() && "inert" in nav) {
      nav.setAttribute("inert", "");
    } else {
      nav.removeAttribute("inert");
    }

    if (header) {
      header.classList.toggle("is-menu-open", open);
      var section = header.closest(".section-header");
      if (section && open) {
        section.classList.remove("is-header-hidden");
      }
    }

    if (overlay) {
      if (open && isMobileNav()) {
        overlay.removeAttribute("hidden");
        overlay.setAttribute("tabindex", "0");
      } else {
        overlay.setAttribute("hidden", "");
        overlay.setAttribute("tabindex", "-1");
      }
      activeOverlay = open ? overlay : null;
    }

    if (isMobileNav()) {
      document.body.classList.toggle("is-b2b-drawer-open", open);
      if (open) {
        var closeBtn = nav.querySelector("[data-site-header-drawer-close]");
        if (closeBtn) {
          window.requestAnimationFrame(function () {
            closeBtn.focus();
          });
        }
      }
    } else {
      document.body.classList.remove("is-b2b-drawer-open");
    }

    if (open) {
      activeNav = nav;
      activeToggle = toggle;
    } else if (activeNav === nav) {
      activeNav = null;
      activeToggle = null;
      activeOverlay = null;
    }
  }

  function closeActiveNav() {
    if (!activeNav || !activeToggle) return;
    setNavOpen(activeNav, activeToggle, false);
  }

  function initHeaderNav(toggle, nav) {
    if (!toggle || !nav || toggle.dataset.bound) return;
    toggle.dataset.bound = "true";

    var header = nav.closest("[data-site-header]");
    var overlay =
      header && header.querySelector("[data-site-header-overlay]");

    toggle.addEventListener("click", function () {
      setNavOpen(nav, toggle, !nav.classList.contains("is-open"));
    });

    if (overlay && !overlay.dataset.bound) {
      overlay.dataset.bound = "true";
      overlay.addEventListener("click", closeActiveNav);
    }

    nav.querySelectorAll("[data-site-header-drawer-close]").forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "true";
      btn.addEventListener("click", closeActiveNav);
    });

    nav.querySelectorAll(".site-header__menu a, .site-header__drawer-brand").forEach(function (link) {
      link.addEventListener("click", function () {
        if (isMobileNav() && nav.classList.contains("is-open")) {
          closeActiveNav();
        }
      });
    });

    nav.addEventListener("keydown", function (event) {
      if (event.key !== "Tab" || !nav.classList.contains("is-open")) return;

      var focusable = nav.querySelectorAll(
        'a[href], button:not([disabled]):not([hidden]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    MOBILE_MQ.addEventListener("change", function () {
      if (!isMobileNav() && nav.classList.contains("is-open")) {
        setNavOpen(nav, toggle, false);
      }
      if (!isMobileNav()) {
        document.body.classList.remove("is-b2b-drawer-open");
        nav.setAttribute("aria-hidden", "false");
      } else if (!nav.classList.contains("is-open")) {
        nav.setAttribute("aria-hidden", "true");
      }
    });

    var closedOnMobile = isMobileNav() && !nav.classList.contains("is-open");
    nav.setAttribute("aria-hidden", closedOnMobile ? "true" : "false");
    if (closedOnMobile && "inert" in nav) {
      nav.setAttribute("inert", "");
    } else {
      nav.removeAttribute("inert");
    }
  }

  function updateHeaderHeight(header) {
    var height = Math.ceil(header.getBoundingClientRect().height);
    document.documentElement.style.setProperty("--site-header-height", height + "px");

    var firstSection = document.querySelector(
      "#main-content > .shopify-section:first-child"
    );
    if (firstSection) {
      firstSection.style.setProperty("--MUSE-first-section-header-overlap", height + "px");
    }
  }

  function updateScrolledState(header) {
    var scrolled = window.scrollY > SCROLL_THRESHOLD;
    header.classList.toggle("is-scrolled", scrolled);
  }

  function updateHeaderVisibility(header, lastScrollY, currentScrollY) {
    var section = header.closest(".section-header");
    if (!section || REDUCED_MOTION_MQ.matches) {
      if (section) section.classList.remove("is-header-hidden");
      return lastScrollY;
    }

    if (header.classList.contains("is-menu-open")) {
      section.classList.remove("is-header-hidden");
      return currentScrollY;
    }

    if (currentScrollY <= SCROLL_THRESHOLD) {
      section.classList.remove("is-header-hidden");
      return currentScrollY;
    }

    var delta = currentScrollY - lastScrollY;

    if (delta > SCROLL_DIRECTION_EPSILON) {
      section.classList.add("is-header-hidden");
    } else if (delta < -SCROLL_DIRECTION_EPSILON) {
      section.classList.remove("is-header-hidden");
    }

    return currentScrollY;
  }

  function onScroll(header, state) {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(function () {
      var currentScrollY = window.scrollY;
      updateScrolledState(header);
      state.lastScrollY = updateHeaderVisibility(
        header,
        state.lastScrollY,
        currentScrollY
      );
      scrollTicking = false;
    });
  }

  function initStickyHeader(header) {
    if (!header || header.dataset.stickyBound) return;
    header.dataset.stickyBound = "true";

    var scrollState = { lastScrollY: window.scrollY };

    updateHeaderHeight(header);
    updateScrolledState(header);
    updateHeaderVisibility(header, scrollState.lastScrollY, scrollState.lastScrollY);

    window.addEventListener("scroll", function () {
      onScroll(header, scrollState);
    }, { passive: true });

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        updateHeaderHeight(header);
      }).observe(header);
    }

    var resizeDebounce = null;
    window.addEventListener("resize", function () {
      clearTimeout(resizeDebounce);
      resizeDebounce = setTimeout(function () {
        updateHeaderHeight(header);
      }, 200);
    });
  }

  if (!window.__b2bHeaderEscapeBound) {
    window.__b2bHeaderEscapeBound = true;
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeActiveNav();
    });
  }

  function initHeaderCart() {
    var badges = document.querySelectorAll("[data-header-cart-count]");
    if (!badges.length) return;

    function setCount(count) {
      var n = parseInt(count, 10) || 0;
      badges.forEach(function (badge) {
        badge.textContent = n > 99 ? "99+" : String(n);
        badge.hidden = n <= 0;
      });
      document.querySelectorAll("[data-open-sidecart]").forEach(function (btn) {
        btn.setAttribute(
          "aria-label",
          n > 0 ? "Cart, " + n + " item" + (n === 1 ? "" : "s") : "Cart"
        );
      });
    }

    fetch("/cart.js")
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        setCount(cart.item_count);
      })
      .catch(function () {});

    var sidecartHeader = document.querySelector(
      "#shopify-section-sidecart .sidecart__header"
    );
    if (sidecartHeader && window.MutationObserver) {
      new MutationObserver(function () {
        var probe = sidecartHeader.querySelector("[data-cart-item-count]");
        if (probe) {
          setCount(probe.getAttribute("data-cart-item-count"));
        }
      }).observe(sidecartHeader, {
        attributes: true,
        subtree: true,
        attributeFilter: ["data-cart-item-count"]
      });
    }
  }

  function initAll() {
    document.querySelectorAll("[data-site-header-toggle]").forEach(function (toggle) {
      var navId = toggle.getAttribute("aria-controls");
      var nav = navId ? document.getElementById(navId) : null;
      initHeaderNav(toggle, nav);
    });

    document.querySelectorAll("[data-site-header]").forEach(initStickyHeader);
    initHeaderCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
